import { http } from "../../../shared/api/http";
import { ChatMessage } from "../models/type";

export async function ordersIdMessagesNew(orderId:any,params:any): Promise<ChatMessage[]> {
  const res = await http.get(`/restaurant/chat/orders/${orderId}/messages/new?lastMessageId=${params.lastMessageId}&limit=${params.limit}`);
  return res.data;
}